import { Record } from 'immutable';
export default Record({
  email: null,
  firstName: null,
  lastName: null
}, 'UserViewRecord');